"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Componente primário de interação com o usuário
 */
const Button = _ref => {
  let {
    children,
    color,
    disabled,
    fullWidth,
    onClick,
    startIcon,
    variant,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_core.Button, {
    color: color,
    disabled: disabled,
    fullWidth: fullWidth,
    onClick: onClick,
    size: "large",
    startIcon: startIcon || null,
    variant: variant,
    className: className
  }, children);
};
exports.Button = Button;
Button.propTypes = {
  /**
   * Texto do botão
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Cor do botão
   */
  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
  /**
   * Se `true` o campo é desabilitado
   */
  disabled: _propTypes.default.bool,
  /**
   * Propriedade para deixar o botão com largura máxima
   */
  fullWidth: _propTypes.default.bool,
  /**
   * Função que será executada quando o botão for clicado
   */
  onClick: _propTypes.default.func.isRequired,
  /**
   * Ícone que aparecerá antes do texto
   */
  startIcon: _propTypes.default.node,
  /**
   * Variante do botão
   */
  variant: _propTypes.default.oneOf(['contained', 'outlined']),
  /**
   * Classe css para o botão
   */
  className: _propTypes.default.string
};
Button.defaultProps = {
  disabled: false,
  fullWidth: false,
  startIcon: null,
  variant: undefined,
  className: null
};
var _default = exports.default = Button;